export default "__VITE_ASSET__BDfLeqxY__"